<template>
  <div class="wrapper information-page">
    <parallax
      class="section page-chat-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xsmall-size-100 md-medium-size-66 mx-auto md-scrollbar"
          >
            <h1 class="title">Datenschutzerklärung</h1>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout md-size-100 mx-auto md-alignment-top-center">
            <div class="md-layout-item md-size-100">
              <div class="document-body">
                <article class="document-content" aria-label="Datenschutzerklärung">
                  <nav class="document-navigation" aria-label="Inhalt der Datenschutzerklärung">
                    <p class="document-navigation-title">Inhalt</p>
                    <a href="#/dataPrivacy" @click.prevent="scrollToSection('privacy-overview')">Datenschutz auf einen Blick</a>
                    <a href="#/dataPrivacy" @click.prevent="scrollToSection('privacy-services')">Hosting, Anmeldung und Kontakt</a>
                    <a href="#/dataPrivacy" @click.prevent="scrollToSection('privacy-rights')">Verantwortliche Stelle und Ihre Rechte</a>
                    <a href="#/dataPrivacy" @click.prevent="scrollToSection('privacy-storage')">Cookies und Anmeldung</a>
                    <a href="#/dataPrivacy" @click.prevent="scrollToSection('privacy-fonts')">Schriftarten und Icons</a>
                  </nav>
                  <h2 id="privacy-overview" tabindex="-1">1. Datenschutz auf einen Blick</h2>
                  <h3>Allgemeine Hinweise</h3>
                  <p>
                    Die folgenden Hinweise geben einen einfachen &Uuml;berblick
                    dar&uuml;ber, was mit Ihren personenbezogenen Daten
                    passiert, wenn Sie diese Website besuchen. Personenbezogene
                    Daten sind alle Daten, mit denen Sie pers&ouml;nlich
                    identifiziert werden k&ouml;nnen. Ausf&uuml;hrliche
                    Informationen zum Thema Datenschutz entnehmen Sie unserer
                    unter diesem Text aufgef&uuml;hrten
                    Datenschutzerkl&auml;rung.
                  </p>
                  <h3>Datenerfassung auf dieser Website</h3>
                  <h4>
                    Wer ist verantwortlich f&uuml;r die Datenerfassung auf
                    dieser Website?
                  </h4>
                  <p>
                    Die Datenverarbeitung auf dieser Website erfolgt durch den
                    Websitebetreiber. Dessen Kontaktdaten k&ouml;nnen Sie dem
                    Abschnitt &bdquo;Hinweis zur Verantwortlichen Stelle&ldquo;
                    in dieser Datenschutzerkl&auml;rung entnehmen.
                  </p>
                  <h4>Wie erfassen wir Ihre Daten?</h4>
                  <p>
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                    diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten
                    handeln, die Sie in einer E-Mail, als Status oder im Chat mit
                    John eingeben.
                  </p>
                  <p>
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung
                    beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                    sind vor allem technische Daten (z.&nbsp;B. Internetbrowser,
                    Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
                    Erfassung dieser Daten erfolgt automatisch, sobald Sie diese
                    Website betreten.
                  </p>
                  <h4>Wof&uuml;r nutzen wir Ihre Daten?</h4>
                  <p>
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie
                    Bereitstellung der Website zu gew&auml;hrleisten.
                  </p>
                  <h4>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</h4>
                  <p>
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft
                    &uuml;ber Herkunft, Empf&auml;nger und Zweck Ihrer
                    gespeicherten personenbezogenen Daten zu erhalten. Sie haben
                    au&szlig;erdem ein Recht, die Berichtigung oder
                    L&ouml;schung dieser Daten zu verlangen. Wenn Sie eine
                    Einwilligung zur Datenverarbeitung erteilt haben,
                    k&ouml;nnen Sie diese Einwilligung jederzeit f&uuml;r die
                    Zukunft widerrufen. Au&szlig;erdem haben Sie das Recht,
                    unter bestimmten Umst&auml;nden die Einschr&auml;nkung der
                    Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des
                    Weiteren steht Ihnen ein Beschwerderecht bei der
                    zust&auml;ndigen Aufsichtsbeh&ouml;rde zu.
                  </p>
                  <p>
                    Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
                    k&ouml;nnen Sie sich jederzeit an uns wenden.
                  </p>
                  <h2 id="privacy-services" tabindex="-1">2. Hosting und Betrieb bei Amazon Web Services</h2>
                  <p>
                    Wir betreiben diese Anwendung bei Amazon Web Services (AWS).
                    Die Website wird über Amazon S3 und CloudFront
                    bereitgestellt; die Anwendungsfunktionen nutzen API Gateway
                    und AWS Lambda. Profile, Ziele, Statusangaben und
                    Chat-Nachrichten werden in Amazon DynamoDB in der AWS-Region
                    Frankfurt (eu-central-1) gespeichert.
                  </p>
                  <p>
                    AWS verarbeitet technische Verbindungsdaten, insbesondere
                    IP-Adresse, angefragte Adresse, Zeitpunkt und
                    Browserinformationen, soweit dies für die Auslieferung und
                    Absicherung der Anwendung erforderlich ist. CloudFront ist
                    ein weltweites Auslieferungsnetz; die Verarbeitung
                    technischer Verbindungsdaten kann daher außerhalb der EU
                    erfolgen. Die Speicherung der Anwendungsdaten in Frankfurt
                    bedeutet nicht, dass sämtliche beteiligten Dienste
                    ausschließlich in der EU arbeiten.
                  </p>
                  <p>
                    Die Bereitstellung der Anwendung erfolgt auf Grundlage von
                    Art. 6 Abs. 1 lit. b DSGVO; der sichere und zuverlässige
                    Betrieb auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Für
                    die Auftragsverarbeitung durch AWS gelten die
                    <a
                      href="https://aws.amazon.com/compliance/gdpr-center/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >AWS-Datenschutzbedingungen</a
                    >, einschließlich des Data Processing Addendum und der darin
                    enthaltenen Regelungen zu internationalen Übermittlungen.
                  </p>
                  <p>
                    Technische Lambda-Protokolle werden nach 30 Tagen gelöscht.
                    Die Datenbank nutzt eine Wiederherstellungshistorie von bis
                    zu 35 Tagen. Bereits gelöschte Daten können innerhalb dieses
                    Zeitraums noch in Sicherungen enthalten sein. Die laufenden
                    Anwendungsdaten werden entsprechend dem unten beschriebenen
                    Speicherzweck aufbewahrt.
                  </p>
                  <h3>Anmeldung mit Auth0 und Google</h3>
                  <p>
                    Für Registrierung und Anmeldung verwenden wir weiterhin
                    Auth0 (ein Dienst von Okta). Verarbeitet werden die Kennung
                    Ihres Kontos, E-Mail-Adresse und, soweit vom Anmeldedienst
                    bereitgestellt, Name und Profilbild sowie technische
                    Anmelde- und Sicherheitsdaten. Die Anwendung ordnet Ihre
                    Daten Ihrer bestehenden Nutzerkennung zu.
                  </p>
                  <p>
                    Der verwendete Auth0-Mandant liegt in der US-Region. Bei
                    einer Anmeldung über Google verarbeitet zusätzlich Google
                    die für die Anmeldung erforderlichen Daten. Diese Dienste
                    können personenbezogene Daten in den USA verarbeiten. Die
                    Anmeldung und Kontoverwaltung dienen der Nutzung der
                    Anwendung (Art. 6 Abs. 1 lit. b DSGVO); Sicherheitsmaßnahmen
                    dienen unserem berechtigten Interesse am Schutz der Konten
                    (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>
                  <p>
                    Weitere Informationen:
                    <a
                      href="https://auth0.com/docs/secure/data-privacy-and-compliance"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Auth0 Datenschutz</a
                    >,
                    <a
                      href="https://www.okta.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Okta Datenschutzerklärung</a
                    >
                    und
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Google Datenschutzerklärung</a
                    >.
                  </p>
                  <h3>Profile, Ziele, Status und Chat</h3>
                  <p>
                    Wir speichern Ihre selbst eingegebenen Profilangaben, Ziele,
                    Fortschrittswerte, Emojis und Texte mit Zeitstempel und
                    Nutzerkennung, um diese beim nächsten Besuch erneut
                    anzuzeigen. Nachrichten im persönlichen Chat werden als
                    Statusangaben zu Ihrem Ziel gespeichert. Die Antworten von
                    John werden anhand hinterlegter Texte erzeugt; dafür wird
                    kein externer KI-Dienst aufgerufen. Rechtsgrundlage ist Art.
                    6 Abs. 1 lit. b DSGVO.
                  </p>
                  <h3>Kontaktformular und E-Mail-Versand</h3>
                  <p>
                    Wenn Sie das Kontaktformular verwenden, verarbeiten wir
                    Ihren Namen, Ihre E-Mail-Adresse und Ihre Nachricht zur
                    Bearbeitung Ihrer Anfrage. Der Versand erfolgt über Amazon
                    Simple Email Service (SES) in Frankfurt an
                    nico.inhoffen@gmail.com. Ihre Adresse wird als
                    Antwortadresse mitgeschickt, damit wir Ihnen antworten
                    können. Der Empfänger verwendet einen Google-Maildienst, der
                    Daten auch außerhalb der EU verarbeiten kann. EmailJS wird
                    nicht verwendet.
                  </p>
                  <p>
                    Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO bei
                    anwendungsbezogenen Anfragen, ansonsten Art. 6 Abs. 1 lit. f
                    DSGVO. Zum Schutz vor automatisiertem Missbrauch speichern
                    wir einen täglich wechselnden Hash Ihrer IP-Adresse und
                    einen Anfragenzähler mit einer automatischen Ablaufzeit von
                    bis zu zwei Tagen; die technische Löschung durch DynamoDB
                    kann zeitversetzt erfolgen. Nachrichtentexte werden vom
                    Kontakt-Endpunkt nicht in der Datenbank oder in
                    Anwendungsprotokollen gespeichert. Die Anfrage wird im
                    E-Mail-Postfach für die Bearbeitung aufbewahrt. Sie können
                    sich weiterhin direkt an die Kontaktadresse der
                    verantwortlichen Stelle wenden.
                  </p>
                  <h2 id="privacy-rights" tabindex="-1">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                  <h3>Datenschutz</h3>
                  <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                    pers&ouml;nlichen Daten sehr ernst. Wir behandeln Ihre
                    personenbezogenen Daten vertraulich und entsprechend den
                    gesetzlichen Datenschutzvorschriften sowie dieser
                    Datenschutzerkl&auml;rung.
                  </p>
                  <p>
                    Wenn Sie diese Website benutzen, werden verschiedene
                    personenbezogene Daten erhoben. Personenbezogene Daten sind
                    Daten, mit denen Sie pers&ouml;nlich identifiziert werden
                    k&ouml;nnen. Die vorliegende Datenschutzerkl&auml;rung
                    erl&auml;utert, welche Daten wir erheben und wof&uuml;r wir
                    sie nutzen. Sie erl&auml;utert auch, wie und zu welchem
                    Zweck das geschieht.
                  </p>
                  <p>
                    Wir weisen darauf hin, dass die Daten&uuml;bertragung im
                    Internet (z.&nbsp;B. bei der Kommunikation per E-Mail)
                    Sicherheitsl&uuml;cken aufweisen kann. Ein l&uuml;ckenloser
                    Schutz der Daten vor dem Zugriff durch Dritte ist nicht
                    m&ouml;glich.
                  </p>
                  <h3>Hinweis zur verantwortlichen Stelle</h3>
                  <p>
                    Die verantwortliche Stelle f&uuml;r die Datenverarbeitung
                    auf dieser Website ist:
                  </p>
                  <p>
                    Mehlhorn, Anna Katharina<br />
                    Kastanienweg 45, 08301 Aue-Bad Schlema
                  </p>

                  <p>E-Mail: anna.k.mehlhorn@gmx.de</p>
                  <p>
                    Verantwortliche Stelle ist die nat&uuml;rliche oder
                    juristische Person, die allein oder gemeinsam mit anderen
                    &uuml;ber die Zwecke und Mittel der Verarbeitung von
                    personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail-Adressen
                    o. &Auml;.) entscheidet.
                  </p>

                  <h3>Speicherdauer</h3>
                  <p>
                    Soweit innerhalb dieser Datenschutzerkl&auml;rung keine
                    speziellere Speicherdauer genannt wurde, verbleiben Ihre
                    personenbezogenen Daten bei uns, bis der Zweck f&uuml;r die
                    Datenverarbeitung entf&auml;llt. Wenn Sie ein berechtigtes
                    L&ouml;schersuchen geltend machen oder eine Einwilligung zur
                    Datenverarbeitung widerrufen, werden Ihre Daten
                    gel&ouml;scht, sofern wir keine anderen rechtlich
                    zul&auml;ssigen Gr&uuml;nde f&uuml;r die Speicherung Ihrer
                    personenbezogenen Daten haben (z.&nbsp;B. steuer- oder
                    handelsrechtliche Aufbewahrungsfristen); im letztgenannten
                    Fall erfolgt die L&ouml;schung nach Fortfall dieser
                    Gr&uuml;nde.
                  </p>
                  <h3>
                    Allgemeine Hinweise zu den Rechtsgrundlagen der
                    Datenverarbeitung auf dieser Website
                  </h3>
                  <p>
                    Sofern Sie in die Datenverarbeitung eingewilligt haben,
                    verarbeiten wir Ihre personenbezogenen Daten auf Grundlage
                    von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a
                    DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1
                    DSGVO verarbeitet werden. Im Falle einer ausdr&uuml;cklichen
                    Einwilligung in die &Uuml;bertragung personenbezogener Daten
                    in Drittstaaten erfolgt die Datenverarbeitung au&szlig;erdem
                    auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in
                    die Speicherung von Cookies oder in den Zugriff auf
                    Informationen in Ihr Endger&auml;t (z.&nbsp;B. via
                    Device-Fingerprinting) eingewilligt haben, erfolgt die
                    Datenverarbeitung zus&auml;tzlich auf Grundlage von &sect;
                    25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
                    Sind Ihre Daten zur Vertragserf&uuml;llung oder zur
                    Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen
                    erforderlich, verarbeiten wir Ihre Daten auf Grundlage des
                    Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir
                    Ihre Daten, sofern diese zur Erf&uuml;llung einer
                    rechtlichen Verpflichtung erforderlich sind auf Grundlage
                    von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann
                    ferner auf Grundlage unseres berechtigten Interesses nach
                    Art. 6 Abs. 1 lit. f DSGVO erfolgen. &Uuml;ber die jeweils
                    im Einzelfall einschl&auml;gigen Rechtsgrundlagen wird in
                    den folgenden Abs&auml;tzen dieser Datenschutzerkl&auml;rung
                    informiert.
                  </p>
                  <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                  <p>
                    Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer
                    ausdr&uuml;cklichen Einwilligung m&ouml;glich. Sie
                    k&ouml;nnen eine bereits erteilte Einwilligung jederzeit
                    widerrufen. Die Rechtm&auml;&szlig;igkeit der bis zum
                    Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
                    unber&uuml;hrt.
                  </p>
                  <h3>
                    Widerspruchsrecht gegen die Datenerhebung in besonderen
                    F&auml;llen sowie gegen Direktwerbung (Art. 21 DSGVO)
                  </h3>
                  <div class="document-notice">
                    <p>
                      Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1
                      lit. e oder f DSGVO erfolgt, haben Sie jederzeit das Recht,
                      aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
                      gegen die Verarbeitung Ihrer personenbezogenen Daten
                      Widerspruch einzulegen. Dies gilt auch für ein auf diese
                      Bestimmungen gestütztes Profiling. Die jeweilige
                      Rechtsgrundlage entnehmen Sie dieser Datenschutzerklärung.
                    </p>
                    <p>
                      Wenn Sie Widerspruch einlegen, verarbeiten wir Ihre
                      personenbezogenen Daten nicht mehr, es sei denn, wir können
                      zwingende schutzwürdige Gründe nachweisen, die Ihre
                      Interessen, Rechte und Freiheiten überwiegen, oder die
                      Verarbeitung dient der Geltendmachung, Ausübung oder
                      Verteidigung von Rechtsansprüchen (Art. 21 Abs. 1 DSGVO).
                    </p>
                    <p>
                      Werden Ihre personenbezogenen Daten für Direktwerbung
                      verarbeitet, haben Sie jederzeit das Recht, dieser
                      Verarbeitung zu widersprechen. Dies gilt auch für Profiling,
                      soweit es mit solcher Direktwerbung verbunden ist. Nach Ihrem
                      Widerspruch werden Ihre personenbezogenen Daten nicht mehr
                      für Direktwerbung verwendet (Art. 21 Abs. 2 DSGVO).
                    </p>
                  </div>
                  <h3>
                    Beschwerde&shy;recht bei der zust&auml;ndigen
                    Aufsichts&shy;beh&ouml;rde
                  </h3>
                  <p>
                    Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den
                    Betroffenen ein Beschwerderecht bei einer
                    Aufsichtsbeh&ouml;rde, insbesondere in dem Mitgliedstaat
                    ihres gew&ouml;hnlichen Aufenthalts, ihres Arbeitsplatzes
                    oder des Orts des mutma&szlig;lichen Versto&szlig;es zu. Das
                    Beschwerderecht besteht unbeschadet anderweitiger
                    verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                  </p>
                  <h3>Recht auf Daten&shy;&uuml;bertrag&shy;barkeit</h3>
                  <p>
                    Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
                    Einwilligung oder in Erf&uuml;llung eines Vertrags
                    automatisiert verarbeiten, an sich oder an einen Dritten in
                    einem g&auml;ngigen, maschinenlesbaren Format
                    aush&auml;ndigen zu lassen. Sofern Sie die direkte
                    &Uuml;bertragung der Daten an einen anderen Verantwortlichen
                    verlangen, erfolgt dies nur, soweit es technisch machbar
                    ist.
                  </p>
                  <h3>Auskunft, L&ouml;schung und Berichtigung</h3>
                  <p>
                    Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
                    jederzeit das Recht auf unentgeltliche Auskunft &uuml;ber
                    Ihre gespeicherten personenbezogenen Daten, deren Herkunft
                    und Empf&auml;nger und den Zweck der Datenverarbeitung und
                    ggf. ein Recht auf Berichtigung oder L&ouml;schung dieser
                    Daten. Hierzu sowie zu weiteren Fragen zum Thema
                    personenbezogene Daten k&ouml;nnen Sie sich jederzeit an uns
                    wenden.
                  </p>
                  <h3>Recht auf Einschr&auml;nkung der Verarbeitung</h3>
                  <p>
                    Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung
                    Ihrer personenbezogenen Daten zu verlangen. Hierzu
                    k&ouml;nnen Sie sich jederzeit an uns wenden. Das Recht auf
                    Einschr&auml;nkung der Verarbeitung besteht in folgenden
                    F&auml;llen:
                  </p>
                  <ul>
                    <li>
                      Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
                      personenbezogenen Daten bestreiten, ben&ouml;tigen wir in
                      der Regel Zeit, um dies zu &uuml;berpr&uuml;fen. F&uuml;r
                      die Dauer der Pr&uuml;fung haben Sie das Recht, die
                      Einschr&auml;nkung der Verarbeitung Ihrer
                      personenbezogenen Daten zu verlangen.
                    </li>
                    <li>
                      Wenn die Verarbeitung Ihrer personenbezogenen Daten
                      unrechtm&auml;&szlig;ig geschah/geschieht, k&ouml;nnen Sie
                      statt der L&ouml;schung die Einschr&auml;nkung der
                      Datenverarbeitung verlangen.
                    </li>
                    <li>
                      Wenn wir Ihre personenbezogenen Daten nicht mehr
                      ben&ouml;tigen, Sie sie jedoch zur Aus&uuml;bung,
                      Verteidigung oder Geltendmachung von Rechtsanspr&uuml;chen
                      ben&ouml;tigen, haben Sie das Recht, statt der
                      L&ouml;schung die Einschr&auml;nkung der Verarbeitung
                      Ihrer personenbezogenen Daten zu verlangen.
                    </li>
                    <li>
                      Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO
                      eingelegt haben, muss eine Abw&auml;gung zwischen Ihren
                      und unseren Interessen vorgenommen werden. Solange noch
                      nicht feststeht, wessen Interessen &uuml;berwiegen, haben
                      Sie das Recht, die Einschr&auml;nkung der Verarbeitung
                      Ihrer personenbezogenen Daten zu verlangen.
                    </li>
                  </ul>
                  <p>
                    Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
                    eingeschr&auml;nkt haben, d&uuml;rfen diese Daten &ndash;
                    von ihrer Speicherung abgesehen &ndash; nur mit Ihrer
                    Einwilligung oder zur Geltendmachung, Aus&uuml;bung oder
                    Verteidigung von Rechtsanspr&uuml;chen oder zum Schutz der
                    Rechte einer anderen nat&uuml;rlichen oder juristischen
                    Person oder aus Gr&uuml;nden eines wichtigen
                    &ouml;ffentlichen Interesses der Europ&auml;ischen Union
                    oder eines Mitgliedstaats verarbeitet werden.
                  </p>
                  <h3>SSL- bzw. TLS-Verschl&uuml;sselung</h3>
                  <p>
                    Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz
                    der &Uuml;bertragung vertraulicher Inhalte, wie zum Beispiel
                    die Eingaben des Chats oder Anfragen, die Sie an uns als
                    Seitenbetreiber senden, eine SSL- bzw.
                    TLS-Verschl&uuml;sselung. Eine verschl&uuml;sselte
                    Verbindung erkennen Sie daran, dass die Adresszeile des
                    Browsers von &bdquo;http://&ldquo; auf
                    &bdquo;https://&ldquo; wechselt und an dem Schloss-Symbol in
                    Ihrer Browserzeile.
                  </p>
                  <p>
                    Wenn die SSL- bzw. TLS-Verschl&uuml;sselung aktiviert ist,
                    k&ouml;nnen die Daten, die Sie an uns &uuml;bermitteln,
                    nicht von Dritten mitgelesen werden.
                  </p>
                  <h2 id="privacy-storage" tabindex="-1">4. Datenerfassung auf dieser Website</h2>
                  <h3>Cookies und Anmeldung</h3>
                  <p>
                    Wir verwenden keine Analyse- oder Werbe-Cookies. Wenn Sie
                    die Website ohne Anmeldung besuchen, setzt die Anwendung
                    keine Cookies zur Anmeldung.
                  </p>
                  <p>
                    Wenn Sie sich anmelden, speichert unser Anmeldedienst Auth0
                    Informationen in Ihrem Browser. Diese sind erforderlich,
                    um Ihre Anmeldung zu ermöglichen, Ihren Anmeldestatus zu
                    merken und Ihr Konto vor Missbrauch zu schützen. Die
                    Cookies zum Anmeldestatus enthalten keine Passwörter.
                  </p>
                  <p>
                    Die Website merkt Ihren Anmeldestatus für bis zu einen Tag.
                    Weitere Informationen zum Anmeldevorgang werden nur
                    vorübergehend gespeichert, bis die Anmeldung abgeschlossen
                    ist oder die Browsersitzung endet. Für Cookies beim
                    Anmeldedienst Auth0 hängt die Speicherdauer von den dort
                    eingerichteten Sitzungs- und Sicherheitseinstellungen ab.
                  </p>
                  <p>
                    Diese Speicherung ist für die von Ihnen gewünschte Anmeldung
                    notwendig und erfordert deshalb keine gesonderte
                    Einwilligung (§ 25 Abs. 2 Nr. 2 TDDDG). Wenn Sie Cookies in
                    Ihrem Browser blockieren, kann die Anmeldung eingeschränkt
                    sein. Sollten wir künftig optionale Analyse- oder
                    Werbedienste einsetzen, holen wir vorher die erforderliche
                    Einwilligung ein.
                  </p>
                  <h2 id="privacy-fonts" tabindex="-1">5. Schriftarten und Icons</h2>
                  <p>
                    Roboto, Roboto Slab, Material Icons, Font Awesome und die
                    Material Design Icons werden mit der Anwendung über AWS
                    ausgeliefert. Dafür nimmt Ihr Browser keine Verbindung zu
                    Google Fonts, Font Awesome oder jsDelivr auf.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollToSection from "@/utils/scrollToSection";

export default {
  name: "dataPrivacyView",
  bodyClass: "dataPrivacy",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/backgrounds/background5.png"),
    },
  },
  methods: {
    scrollToSection,
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/information-pages.scss";
</style>
